<nav class="sidebar">
  <a
    class="sidebar__logo"
    routerLink="/dashboard"
    data-testid="sidebar-logo"
    (click)="onNavSelect()"
  >
    <img
      [src]="
        theme.theme() === 'dark'
          ? '../../assets/img/logo-dark.png'
          : '../../assets/img/logo.png'
      "
      alt="CONNECT"
    />
  </a>

  <div class="sidebar__scroll">
    <ul class="sidebar__nav">
      <li>
        <a
          routerLink="/dashboard"
          routerLinkActive="is-active"
          data-testid="sidebar-nav-dashboard"
          (click)="onNavSelect()"
        >
          <span class="material-icons" aria-hidden="true">dashboard</span>
          <span>Dashboard</span>
        </a>
      </li>
      <li>
        <a
          routerLink="/invitations"
          routerLinkActive="is-active"
          data-testid="sidebar-nav-invitations"
          (click)="onNavSelect()"
        >
          <span class="material-icons" aria-hidden="true">mail</span>
          <span>Invitations</span>
        </a>
      </li>
      <li>
        <a
          routerLink="/proposals"
          routerLinkActive="is-active"
          data-testid="sidebar-nav-proposals"
          (click)="onNavSelect()"
        >
          <span class="material-icons" aria-hidden="true">pending_actions</span>
          <span>Pending</span>
        </a>
      </li>
      <li>
        <!-- Origin-aware highlight (see `activeNavActive`): lit on the Active
             list and on the workspace when reached FROM Active, but NOT when the
             workspace was opened from the nav-less Project Overview page. -->
        <a
          routerLink="/active"
          [class.is-active]="activeNavActive"
          data-testid="sidebar-nav-active"
          (click)="onNavSelect()"
        >
          <span class="material-icons" aria-hidden="true">work</span>
          <span>Active</span>
        </a>
      </li>
      <li>
        <a
          routerLink="/scheduling"
          routerLinkActive="is-active"
          data-testid="sidebar-nav-scheduling"
          (click)="onNavSelect()"
        >
          <span class="material-icons" aria-hidden="true">calendar_month</span>
          <span>Scheduling</span>
        </a>
      </li>
      <li>
        <a
          routerLink="/project-history"
          routerLinkActive="is-active"
          data-testid="sidebar-nav-project-history"
          (click)="onNavSelect()"
        >
          <span class="material-icons" aria-hidden="true">history</span>
          <span>History</span>
        </a>
      </li>
      <li>
        <a
          routerLink="/receivables"
          routerLinkActive="is-active"
          data-testid="sidebar-nav-receivables"
          (click)="onNavSelect()"
        >
          <span class="material-icons" aria-hidden="true">payments</span>
          <span>Receivables</span>
        </a>
      </li>
    </ul>

    <div class="sidebar__group-label">My Account</div>
    <ul class="sidebar__nav">
      <li>
        <a
          routerLink="/services-zones"
          routerLinkActive="is-active"
          data-testid="sidebar-nav-services-zones"
          (click)="onNavSelect()"
        >
          <span class="material-icons" aria-hidden="true">construction</span>
          <span>Services &amp; Zones</span>
        </a>
      </li>
      <li>
        <a
          routerLink="/documents"
          routerLinkActive="is-active"
          data-testid="sidebar-nav-documents"
          (click)="onNavSelect()"
        >
          <span class="material-icons" aria-hidden="true">description</span>
          <span>Licenses</span>
        </a>
      </li>
      <li>
        <a
          routerLink="/manageaccount"
          routerLinkActive="is-active"
          data-testid="sidebar-nav-manageaccount"
          (click)="onNavSelect()"
        >
          <span class="material-icons" aria-hidden="true">person</span>
          <span>Profile</span>
        </a>
      </li>
      <li>
        <a
          routerLink="/settings"
          routerLinkActive="is-active"
          data-testid="sidebar-nav-settings"
          (click)="onNavSelect()"
        >
          <span class="material-icons" aria-hidden="true">settings</span>
          <span>Settings</span>
        </a>
      </li>
      <li>
        <a
          routerLink="/contact"
          routerLinkActive="is-active"
          data-testid="sidebar-nav-contact"
          (click)="onNavSelect()"
        >
          <span class="material-icons" aria-hidden="true">info</span>
          <span>Contact Us</span>
        </a>
      </li>
    </ul>
  </div>

  <div class="sidebar__footer">
    <button
      type="button"
      class="sidebar__logout"
      data-testid="sidebar-logout"
      (click)="logout()"
    >
      <span class="material-icons" aria-hidden="true">logout</span>
      <span>Logout</span>
    </button>
    <button
      type="button"
      class="sidebar__theme-toggle"
      data-testid="sidebar-theme-toggle"
      [disabled]="aliasSession.isAliased()"
      [attr.aria-label]="
        aliasSession.isAliased()
          ? 'Theme can\'t be changed while viewing a vendor in read-only guidance mode'
          : theme.current === 'dark'
            ? 'Switch to light theme'
            : 'Switch to dark theme'
      "
      [attr.title]="
        aliasSession.isAliased()
          ? 'Theme can\'t be changed while viewing a vendor in read-only guidance mode'
          : null
      "
      [attr.aria-pressed]="theme.current === 'dark'"
      (click)="toggleTheme()"
    >
      <span class="material-icons" aria-hidden="true">
        {{ theme.current === 'dark' ? 'light_mode' : 'dark_mode' }}
      </span>
    </button>
  </div>
</nav>
